import {
  getLocalStorageItem,
  setLocalStorageItem,
  removeLocalStorageItem,
} from "./storage";

const STORAGE_KEY = "asos_my_size_profile_dismissed";

export const getMySizeProfileDismissed = (): boolean =>
  getLocalStorageItem(STORAGE_KEY) === true;

export const setMySizeProfileDismissed = (isDismissed: boolean): void => {
  setLocalStorageItem(STORAGE_KEY, isDismissed);
};

export const clearMySizeProfileDismissed = (): void => {
  removeLocalStorageItem(STORAGE_KEY);
};
